import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-notification-message',
    templateUrl: './notification-message.component.html',
    styleUrls: ['./notification-message.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatButtonModule, AsyncPipe, TranslateModule]
})
export class NotificationMessageComponent {
  constructor(private matSnackBarRef: MatSnackBarRef<NotificationMessageComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public message: Observable<string>) {
  }

  dismiss() {
    this.matSnackBarRef.dismiss();
  }
}